import CardGeneric from 'core/modules/components/cards/components/CardGeneric';
import PropTypes from 'prop-types';
import React from 'react';
import useChatbotPracticeSummary from '../../hooks/useChatbotPracticeSummary';

const ChatbotPracticeSummary = ({ firstName, activityResults = [], sessionKCs = [], lessonTitle }) => {
  const { title, skillsTitle, answersTitle, robotModifier, robotLabel } = useChatbotPracticeSummary({ activityResults, firstName });

  return (
    <div className="ai-practice-view__summary">
      <CardGeneric>
        <div className="ai-practice-view__lesson-title">
          <div className="ai-practice-view__lesson-title-text" dangerouslySetInnerHTML={{ __html: lessonTitle }} />
        </div>
        <div className="ai-practice-view__summary-content">
          {/* Upper section with padding */}
          <div className="ai-practice-view__summary-upper-section">
            {/* Title + state robot */}
            <div className="ai-practice-view__summary-celebration">
              <h2 className="ai-practice-view__summary-title">{title}</h2>
              <div
                aria-label={robotLabel}
                className={`ai-practice-view__summary-celebration-image ai-practice-view__summary-celebration-image--${robotModifier}`}
                role="img"
              />
            </div>

            {/* Skills worked in the session — always shown; only the header is reframed by state */}
            {sessionKCs.length > 0 && (
              <div className="ai-practice-view__summary-learning-sections">
                <div className="ai-practice-view__summary-section">
                  <h3 className="ai-practice-view__summary-section-title">{skillsTitle}</h3>
                  <ul className="ai-practice-view__summary-list">
                    {sessionKCs.map((kc, index) => (
                      <li key={kc.referenceId ?? index} className="ai-practice-view__summary-list-item">
                        {kc.name}.
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>

          {/* Separator */}
          <div className="ai-practice-view__summary-separator"></div>

          {/* Tus respuestas section */}
          <div className="ai-practice-view__summary-answers-section">
            <h3 className="ai-practice-view__summary-answers-title">{answersTitle}</h3>
            <div className="ai-practice-view__summary-responses">
              {activityResults.map((result, index) => (
                <div
                  key={result.activityInstanceId ?? index}
                  className={`ai-practice-view__summary-response-indicator ${
                    result.isCorrect ? 'ai-practice-view__summary-response-indicator--correct' : 'ai-practice-view__summary-response-indicator--incorrect'
                  }`}
                >
                  <span className="ai-practice-view__summary-response-number">{index + 1}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardGeneric>
    </div>
  );
};

ChatbotPracticeSummary.propTypes = {
  firstName: PropTypes.string,
  activityResults: PropTypes.arrayOf(
    PropTypes.shape({
      isCorrect: PropTypes.bool,
      response: PropTypes.object,
      activityInstanceId: PropTypes.string,
      associatedKC: PropTypes.string,
    })
  ),
  sessionKCs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      score: PropTypes.number,
      referenceId: PropTypes.string,
    })
  ),
  lessonTitle: PropTypes.string,
};

export default ChatbotPracticeSummary;
